import { useQuery } from "react-query"
import {
  getUserSceneCount,
  UserSceneCountResponse,
} from "../util/backend_api/users"

export function useUserSceneCount(scene: string | null | undefined) {
  return useQuery<UserSceneCountResponse>(
    ["user_scene_count", scene],
    () => getUserSceneCount(scene as string),
    {
      enabled: !!scene,
      staleTime: 5 * 60 * 1000,
      retry: false,
    },
  )
}
